import React from 'react';

const Conclusion = () => {
  return (
    <section className="py-20 text-center max-w-3xl mx-auto">
      <h2 className="text-3xl font-black mb-6 uppercase tracking-tighter">Your Journey Starts Here</h2>
      <p className="text-gray-600 dark:text-gray-400 leading-relaxed mb-8">
        The <strong>TDEE Intelligence Lab</strong> is more than just a calculator; it is your partner in physical transformation. By understanding your metabolic rate and caloric needs, you remove the guesswork from your fitness journey. We are proud to provide a tool that is fast, free, and private for everyone seeking a healthier life.
      </p>
      <div className="text-[10px] font-black uppercase tracking-[0.5em] text-blue-600">
        Science • Precision • Transformation
      </div>
    </section>
  );
};

export default Conclusion;